module.exports = __webpack_public_path__ + "img/lg_ring_r_0_0_0@3x.9b12c31a.png";